import { AttrField, NumberField, OrmModel, StringField, BelongsToField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import {
  AutomationFlowStatus,
  type AutomationFlowInterface,
  type AutomationFlowSettings,
  type AutomationFlowStatistics,
} from '@/data/models/domain/automations/types'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'

@OrmModel(modelNames.AUTOMATION_FLOW)
export default class AutomationFlow extends BaseModel implements AutomationFlowInterface {
  @StringField()
  public name: string

  @StringField(AutomationFlowStatus.DRAFT)
  public status: AutomationFlowStatus

  @AttrField()
  public settings: AutomationFlowSettings

  @NumberField()
  public stepsWithMessagesCount: number

  @NumberField()
  public stepsCount: number

  @StringField()
  public createdById: string

  @BelongsToField(UserPersonalInfo, 'createdById')
  public createdBy: UserPersonalInfo

  @StringField()
  public updatedAt: string

  @StringField()
  public lastTriggeredAt: string

  @AttrField()
  public stats: AutomationFlowStatistics

  public get hasContactsInFlow() {
    return !!this.lastTriggeredAt
  }
}
